import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CopToplamaAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "GeriDonusumListe";
        super(baseUrl);
    }
    getGeriDonusumListe(mahalleKodu: number, caddeSokakKodu?: number) {
        return this.get("", { params: { caddeSokakKodu: caddeSokakKodu, mahalleKodu: mahalleKodu } });
    }
}

export default new CopToplamaAPI();